import { createPremiumIcon, node } from "~/util/dom";
import createSDSIcon from "../icon";
import { MYMAPS_DROP_DOWN, CLOSE } from "../sds-compatible-icons";
import Tooltip, { ETooltipFlow } from "../tooltip";

interface IData {
	title: string;
	disabled: boolean;
	disabledTooltip: string;
	active: boolean;
	icon: "none" | "dropdown" | "premium" | "close";
}

interface IOpts {
	config?: Partial<IData>;
	onClick?: () => void;
}

export default class MyMapsFilterItem {
	_opts: IOpts;

	_data: IData;

	_origData: IData;

	_dom: {
		container: HTMLSpanElement;
		textPart: HTMLSpanElement;
		rightPart: HTMLSpanElement;
	};

	_tooltip: Tooltip;

	constructor(opts: IOpts) {
		this._opts = {
			config: null,
			onClick: () => {},
			...opts,
		};
		this._data = {
			title: "",
			disabled: false,
			disabledTooltip: "",
			active: false,
			icon: "none",
			...opts.config,
		};
		this._origData = structuredClone(this._data);
		this._tooltip = null;

		this._build();
		this._updateUI();
	}

	get container() {
		return this._dom.container;
	}

	set update(newData: Partial<IData>) {
		this._data = Object.assign(this._data, newData);
		this._updateUI();
	}

	reset() {
		this.update = structuredClone(this._origData);
	}

	_build() {
		const container = node("span", { className: "mymaps__filterItem" });
		const textPart = node("span", { className: "mymaps__filterItem__text" });
		const rightPart = node("span", { className: "mymaps__filterItem__right" });

		this._dom = {
			container,
			textPart,
			rightPart,
		};
		this._dom.container.append(textPart, rightPart);
		this._dom.container.addEventListener("click", event => {
			event.preventDefault();
			event.stopPropagation();
			this._opts.onClick();
		});
	}

	_updateUI() {
		this._dom.textPart.textContent = this._data.title;
		this._dom.rightPart.innerHTML = "";
		this._dom.container.classList[this._data.active ? "add" : "remove"]("active");
		this._dom.container.classList[this._data.disabled ? "add" : "remove"]("disabled");
		this._dom.container.setAttribute("data-icon", this._data.icon);

		if (this._tooltip) {
			this._tooltip.destroy();
			this._tooltip = null;
		}

		if (this._opts.config.disabledTooltip) {
			const content = node("p", { innerHTML: this._opts.config.disabledTooltip, className: "mymaps__filterItem-tooltipContent" });
			/* eslint-disable-next-line */
			const tooltip = new Tooltip({
				anchor: this._dom.container,
				trigger: this._dom.container,
				triggerEventType: "pointerenter",
				content,
				arrow: true,
				flow: ETooltipFlow.CENTER,
				offset: [0, 0, 2, 0],
				hideTimeout: 500,
				width: 232,
			});
		}

		switch (this._data.icon) {
			case "none":
				break;

			case "dropdown":
				this._dom.rightPart.append(createSDSIcon({ symbol: MYMAPS_DROP_DOWN }));
				break;

			case "premium":
				this._dom.rightPart.append(createPremiumIcon());
				break;

			case "close":
				this._dom.rightPart.append(createSDSIcon({ symbol: CLOSE }));
				break;

			default:
		}
	}
}
